module.exports = __webpack_public_path__ + "static/media/Illus-SummerLate.ba6b420f.png";